// /src/pages/private/settings/Tools.jsx

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { IdcardOutlined } from '@ant-design/icons';
import { useAuth } from '../../../authContext';
import { ExtensionSettings } from './ExtensionSettings';
import discordIcon from '../../../medias/discord-white.png';
import HandlesTable from './Handles';

function Tools() {
  const { t } = useTranslation();
  const { handles } = useAuth();
  const [discordUser, setDiscordUser] = useState(null);

  const handlesArray = (handles || []).map((handleObj) => ({
    ...handleObj,
    found: handleObj.found !== undefined ? handleObj.found : handleObj.handleFound,
  }));

  const hasValidMembership = handlesArray.some(
    (handle) => handle.membership === 'main' || handle.membership === 'affiliate',
  );
  const noHandlesProvided = handlesArray.length === 0 || !discordUser;
  const invalidMembership = handlesArray.length > 0 && !hasValidMembership;

  useEffect(() => {
    const fetchDiscordUser = async () => {
      try {
        const response = await axios.post(
          '/api/auth/discord/user',
          {},
          {
            headers: {
              'Content-Type': 'application/json',
            },
            withCredentials: true,
          },
        );

        if (response.data) {
          setDiscordUser(response.data);
        } else {
          setDiscordUser(null);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données Discord:', error);
        setDiscordUser(null);
      }
    };

    fetchDiscordUser();
  }, []);

  const handleLinkDiscord = async () => {
    try {
      const response = await axios.post('/api/auth/discord', {}, { withCredentials: true });

      const data = response.data;

      if (data.url) {
        window.location.href = data.url;
      } else {
        console.error('URL Discord non reçue du serveur');
      }
    } catch (error) {
      console.error('Erreur lors de la tentative de liaison de compte Discord:', error);
    }
  };

  return (
    <div className="user-settings-container tools-page">
      <h2 className="settings-h2">{t('ToolsSettingsTitle')}</h2>

      <header className="user-settings-section tools-page__section-heading">
        <h3 className="settings-h3">{t('toolsRsiDiscordSection')}</h3>
      </header>

      {(noHandlesProvided || invalidMembership) && (
        <div className="tools-alerts">
          {noHandlesProvided && (
            <p className="tools-alert tools-alert--warning" role="alert">
              {t('toolsWarningRsiDiscordRequired')}
            </p>
          )}
          {invalidMembership && (
            <p className="tools-alert tools-alert--warning" role="alert">
              {t('toolsWarningMembershipRestricted')}
            </p>
          )}
        </div>
      )}

      <div className="tools-section-stack">
        <section
          className="tools-card tools-card--wide"
          aria-labelledby="tools-rsi-title"
        >
          <div className="tools-card__lead-inline">
            <div className="tools-card__icon-wrap">
              <IdcardOutlined className="tools-card__icon" aria-hidden />
            </div>
            <div>
              <h4 id="tools-rsi-title" className="tools-card__title">
                {t('toolsCardRsiTitle')}
              </h4>
              <p className="tools-card__subtitle">{t('toolsCardRsiDesc')}</p>
            </div>
          </div>

          <div className="tools-card__stretch">
            <HandlesTable />
          </div>
        </section>
      </div>

      {hasValidMembership && (
        <>
          <header className="user-settings-section tools-page__section-heading">
            <h3 className="settings-h3">{t('ToolsSettingsSection')}</h3>
          </header>

          <div className="tools-card tools-card--wide tools-card--extension">
            <ExtensionSettings />
          </div>
        </>
      )}
    </div>
  );
}

export default Tools;
